import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DataService } from "src/app/shared/Services/data.service";
import { GetCurrentShift } from 'src/app/shared/Services/getCurrentShift';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import pdfMake from "pdfmake/build/pdfMake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-operator-performance-report',
  templateUrl: './operator-performance-report.component.html',
  styleUrls: ['./operator-performance-report.component.scss'],
})
export class OperatorPerformanceReportComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private cancelPreviousRequests$ = new Subject<void>();
  breadCrumbItems: Array<{}> = [];
  userDetails: any;
  custId: any;
  custName: any;
  timezone: string = 'UTC';
  departmentData: any[] = [];
  selectedDepartment: any;
  selectedDepartmentId: any;
  selectedDepartmentShift: any[] = [];
  shiftData: any[] = [];
  shiftName: string = 'All Shift';
  selectedShiftId: string = 'All Shift';
  currentShiftData: any;
  operatorData: any[] = [];
  selectedoperator: any = '';
  selectedDateRange: string = 'Yesterday';
  showCustomDate: boolean = false;
  fromDate: string = '';
  toDate: string = '';
  mindate: string = '';
  maxdate: string = '';
  maxToDate: string = '';
  showTable: boolean = false;
  tableData: any[] = [];
  isLoading: boolean = false;
  action: string = '';
  pdfBool: boolean = false;
  csvBool: boolean = false;
  exportViaMail: boolean = false;
  mailform: FormGroup;
  base64String: string = '';
  private activeModal: NgbModalRef;

  hasBreakdown: boolean = false;
  hasInterlock: boolean = false;
  hasPin2: boolean = false;
  currentPage = 1;
  itemsPerPage = 5;
  pageSize;
  performanceChart: any;

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private dataservice: DataService,
    private toastr: ToastrService,
    private currShift: GetCurrentShift,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: 'K2' },
      { label: 'Operator Report', active: true },
    ];

    this.mailform = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.userDetails = JSON.parse(sessionStorage.getItem('currentUser') || '{}');
    this.custId = this.userDetails?.user?.custId;
    this.custName = this.userDetails?.user?.name;
    this.timezone = this.userDetails?.user?.timeZone || 'UTC';

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const oneYearBack = new Date(today);
    oneYearBack.setFullYear(today.getFullYear() - 1);

    this.mindate = oneYearBack.toISOString().split('T')[0];
    this.maxdate = yesterday.toISOString().split('T')[0];

    this.convertImageToBase64();
    this.getDepartment();
  }

  getDepartment() {
    this.departmentData = [];
    this.dataservice
      .get(`department?custId=${this.custId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res?.data?.length) {
            this.departmentData = res['data'];
            this.selectedDepartment = this.departmentData[0].departmentName;
            this.selectedDepartmentId = this.departmentData[0].departmentId;
            this.applyDepartmentShifts(this.departmentData[0]);
          }
        },
        error: () => this.toastr.error('Failed to load departments', 'Error'),
      });
  }

  select_Department() {
    const dept = this.departmentData.find(
      (d) => d.departmentName === this.selectedDepartment
    );
    if (dept) {
      this.selectedDepartmentId = dept.departmentId;
      this.applyDepartmentShifts(dept);
    }
  }

  private applyDepartmentShifts(dept: any) {
    this.selectedDepartmentShift = dept.shiftData || [];

    this.shiftData = [{ shiftName: 'All Shift' }, ...this.selectedDepartmentShift];
    this.shiftName = 'All Shift';
    this.selectedShiftId = 'All Shift';
    console.log('Selected Department Shifts:', this.selectedDepartmentShift,this.timezone);
    this.currentShiftData = this.currShift.getCurrentShift(
      this.selectedDepartmentShift,
      this.timezone
    );
    console.log('Current Shift Data:', this.currentShiftData);

    if (this.currentShiftData?.currentDate) {
      this.maxdate = moment(this.currentShiftData.currentDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
    }
    console.log('Current Shift Data:', this.maxdate);

    this.applyDateRange(this.selectedDateRange);
    this.getUser();
  }

  onShiftChange(shiftName: string) {
    const shift = this.shiftData.find((s) => s.shiftName === shiftName);
    this.selectedShiftId = shift?.usershiftId || 'All Shift';
    this.getData();
  }

  select_operator() {
    this.getData();
  }

  getUser() {
    this.dataservice
      .get('api/user')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const users = Array.isArray(res) ? res : res?.data || [];
          this.operatorData = users.filter((u: any) => u.role === 'OPERATOR');
          if (this.operatorData.length) {
            this.selectedoperator = this.operatorData[0].name;
          }
          this.getData();
        },
        error: () => this.toastr.error('Server Unreachable', 'Error'),
      });
  }

  onDateChange(value: string) {
    this.selectedDateRange = value;
    this.showCustomDate = value === 'custome';
    this.applyDateRange(value);
    if (value !== 'custome') {
      this.getData();
    }
  }

  private applyDateRange(range: string) {
    const anchor = moment(this.maxdate);

    switch (range) {
      case 'Yesterday':
        this.fromDate = anchor.format('YYYY-MM-DD');
        this.toDate = anchor.format('YYYY-MM-DD');
        break;

      case '1weak':
        this.fromDate = anchor.clone().subtract(6, 'days').format('YYYY-MM-DD');
        this.toDate = anchor.format('YYYY-MM-DD');
        break;

      case '15Days':
        this.fromDate = anchor.clone().subtract(14, 'days').format('YYYY-MM-DD');
        this.toDate = anchor.format('YYYY-MM-DD');
        break;

      case 'custome':
        if (!this.fromDate) this.fromDate = anchor.format('YYYY-MM-DD');
        if (!this.toDate) this.toDate = anchor.format('YYYY-MM-DD');
        this.updateCustomToDateMax();
        break;
    }
  }

  onFromDateChange() {
    this.updateCustomToDateMax();
    if (this.toDate > this.maxToDate) {
      this.toDate = this.maxToDate;
    }
  }

  private updateCustomToDateMax() {
    if (this.fromDate) {
      const thirtyDayCap = moment(this.fromDate)
        .add(29, 'days')
        .format('YYYY-MM-DD');
      this.maxToDate = thirtyDayCap < this.maxdate ? thirtyDayCap : this.maxdate;
    }
  }

  changeMax() {
    if (this.fromDate > this.toDate) {
      this.fromDate = this.toDate;
    }
  }

  getData() {
    this.cancelPreviousRequests$.next();
    if (!this.fromDate || !this.toDate) {
      this.toastr.warning('Please select a valid date range', 'Warning');
      return;
    }
    if (this.fromDate > this.toDate) {
      this.toastr.warning('From Date cannot be after To Date', 'Warning');
      return;
    }

    this.isLoading = true;
    this.showTable = false;
    this.tableData = [];
    let param = {
      custId: this.custId,
      usershiftId: this.selectedShiftId,
      operatorName: this.selectedoperator,
      department: this.selectedDepartment,
      fromDate: this.fromDate,
      toDate: this.toDate,
      departmentId: this.selectedDepartmentId,
    }
    this.dataservice
      .reportApi("reports/operator", param)
      .pipe(takeUntil(this.destroy$))
      .pipe(takeUntil(this.cancelPreviousRequests$))
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          const data = Array.isArray(res['operatordata']) ? res['operatordata'] : res?.['operatordata'] || [];
          if (data.length) {
            this.tableData = data;
            this.showTable = true;
            this.hasBreakdown =
              this.tableData?.some((item) =>
                Object.prototype.hasOwnProperty.call(item, "breakdown")
              ) ?? false;

            this.hasInterlock =
              this.tableData?.some((item) =>
                Object.prototype.hasOwnProperty.call(item, "interlock")
              ) ?? false;

            this.hasPin2 =
              this.tableData?.some((item) =>
                Object.prototype.hasOwnProperty.call(item, "pin2_count")
              ) ?? false;
            this.getPerformanceChart(data)
          } else {
            this.showTable = true;
            this.getPerformanceChart(null)
            this.toastr.info('No data found for the selected filters', 'Info');
          }
        },
        error: () => {
          this.showTable = true;
          this.isLoading = false;
          this.toastr.error('Failed to fetch report data', 'Error');
        },
      });
  }

  getPerformanceChart(data: any[]) {
    if (!data || !data.length) {
      this.performanceChart = {
        title: {
          text: "No Data Available",
          left: "center",
          top: "middle",
          textStyle: { color: "#999", fontSize: 16, fontWeight: "bold" },
        },
        xAxis: { show: false },
        yAxis: { show: false },
        series: [],
      };
      return;
    }

    const dateArray: string[] = [];
    const start = new Date(this.fromDate);
    const end = new Date(this.toDate);
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      dateArray.push(new Date(d).toISOString().split('T')[0]);
    }

    const datePerformanceMap: Record<string, number[]> = {};
    data.forEach((item) => {
      const date = item.date;
      if (!datePerformanceMap[date]) datePerformanceMap[date] = [];
      datePerformanceMap[date].push(item.performance ?? 0);
    });

    const seriesData = dateArray.map((date) => {
      const values = datePerformanceMap[date];
      if (!values || values.length === 0) return 0;
      const avg = values.reduce((a, b) => a + b, 0) / values.length;
      return parseFloat(avg.toFixed(2));
    });

    const machineBreakdownMap: Record<string, { name: string; perf: number }[]> = {};
    data.forEach((item) => {
      if (!machineBreakdownMap[item.date]) machineBreakdownMap[item.date] = [];
      machineBreakdownMap[item.date].push({
        name: item.deviceName,
        perf: parseFloat((item.performance ?? 0).toFixed(2)),
      });
    });

    this.performanceChart = {
      title: {
        text: "Daily Performance (%)",
        left: "left",
        top: "top",
        textStyle: { fontSize: 14, fontWeight: "bold" },
      },
      grid: {
        left: "5%",
        right: "6%",
        bottom: "5%",
        top: "20%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          restore: { title: "Reset" },
        },
      },
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ccc",
        borderWidth: 1,
        textStyle: { color: "#333", fontSize: 12 },
        formatter: (params: any[]) => {
          const date = params[0].axisValue;
          const avgVal = params[0].value;
          // const machines = machineBreakdownMap[date] || [];

          let tooltipText = `<b>Date: ${date}</b><br/>`;
          tooltipText += `<b>Performance: ${avgVal}%`;

          // tooltipText += `<b>Avg Performance: ${avgVal}%</b><br/><hr style="margin:4px 0"/>`;

          // machines.forEach((m) => {
          //   tooltipText += `
          //   <span style="
          //     display:inline-block;
          //     margin-right:5px;
          //     border-radius:10px;
          //     width:8px;height:8px;
          //     background-color:#4CAF50;
          //   "></span>
          //   ${m.name}: <b>${m.perf}%</b><br/>
          // `;
          // });

          return tooltipText;
        },
      },
      xAxis: {
        type: "category",
        data: dateArray,
        name: "Date",
        nameLocation: "middle",
        nameGap: 25,
        axisLabel: {
          rotate: 30,
          fontSize: 10,
          formatter: (value: string) => value.slice(5), // "MM-DD"
        },
        axisLine: { lineStyle: { color: "#333" } },
      },
      yAxis: {
        type: "value",
        name: "Performance (%)",
        nameLocation: "middle",
        nameGap: 45,
        axisLine: { lineStyle: { color: "#333" } },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      dataZoom: [
        { type: "inside", start: 0, end: 100 },
      ],
      series: [
        {
          name: "Avg Performance",
          type: "bar",
          data: seriesData,
          itemStyle: { color: "#4CAF50" },
          label: {
            show: true,
            position: "top",
            fontSize: 10,
            fontWeight: "bold",
            color: "#000",
            formatter: (params: any) => (params.value === 0 ? "" : `${params.value}%`),
          },
        },
      ],
    };
  }
  perfchartInstance: any;
  onperfChartInit(ec: any) {
    this.perfchartInstance = ec;
  }
  onPageChange(pageNum: number): void {
    this.pageSize = this.itemsPerPage * (pageNum - 1);
  }
  openModal(templatepdf: any, _data: any, act: string) {
    this.action = act;
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
    this.activeModal = this.modalService.open(templatepdf, { centered: true });
  }

  closeModal() {
    this.activeModal?.close();
  }

  pdf() {
    this.pdfBool = true;
    this.csvBool = false;
  }

  csv() {
    this.csvBool = true;
    this.pdfBool = false;
  }

  directExpo() {
    this.exportViaMail = false;
    this.pdfBool = false;
    this.csvBool = false;
    this.mailform.reset();
  }

  mailexport() {
    this.exportViaMail = true;
    this.pdfBool = false;
    this.csvBool = false;
  }

  cancel() {
    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
  }

  download() {
    if (!this.pdfBool && !this.csvBool) {
      this.pdfBool = true;
    }

    if (this.pdfBool && !this.exportViaMail) {
      this.exportPdf();
    } else if (this.csvBool && !this.exportViaMail) {
      this.exportCsv();
    } else if (this.pdfBool && this.exportViaMail) {
      this.emailExport('pdf');
    } else if (this.csvBool && this.exportViaMail) {
      this.emailExport('csv');
    }

    this.pdfBool = false;
    this.csvBool = false;
    this.exportViaMail = false;
    this.mailform.reset();
  }

  private exportPdf() {
    const performancechartImage = this.perfchartInstance?.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });

    const reportDate = moment(this.fromDate).format("DD-MM-YYYY");
    const pdfName = `Operator Report ${reportDate}`;
    const today = moment().format("YYYY-MM-DD HH:mm:ss");
    const year = moment().format("YYYY");

    // ── PDF Header Row ─────────────────────────────────────────────────────
    const headerRow: any[] = [
      { text: "Date", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Machine Name", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Operator Name", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Available Time (mins)", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Running (mins)", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Idle (mins)", fillColor: "#007d79", bold: true, color: "#fff" },
      ...(this.hasBreakdown
        ? [{ text: "Breakdown (mins)", fillColor: "#007d79", bold: true, color: "#fff" }]
        : []),
      ...(this.hasInterlock
        ? [{ text: "Interlock (mins)", fillColor: "#007d79", bold: true, color: "#fff" }]
        : []),
      { text: "Off (mins)", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Downtime (mins)", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Qty Planned", fillColor: "#007d79", bold: true, color: "#fff" },
      ...(this.hasPin2
        ? [
          { text: "Part Count 1", fillColor: "#007d79", bold: true, color: "#fff" },
          { text: "Part Count 2", fillColor: "#007d79", bold: true, color: "#fff" },
        ]
        : [{ text: "Qty Produced", fillColor: "#007d79", bold: true, color: "#fff" }]),
      { text: "Qty Rejected", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Availability(%)", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Performance(%)", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "Quality(%)", fillColor: "#007d79", bold: true, color: "#fff" },
      { text: "OEE(%)", fillColor: "#007d79", bold: true, color: "#fff" },
    ];

    // ── PDF Body Rows ──────────────────────────────────────────────────────
    const bodyRows = this.tableData.map((val: any) => [
      val.date ?? "--",
      val.deviceName ?? "--",
      val.operatorName ?? "--",
      val.availableTime ?? 0,
      val.running ?? 0,
      val.idle ?? 0,
      ...(this.hasBreakdown ? [val.breakdown ?? 0] : []),
      ...(this.hasInterlock ? [val.interlock ?? 0] : []),
      val.off ?? 0,
      val.downtime ?? 0,
      val.partPlanned ? parseFloat(val.partPlanned).toFixed(0) : 0,
      ...(this.hasPin2
        ? [
          val.pin1_count ?? 0,
          val.pin2_count ?? "NA",
        ]
        : [val.pin1_count ?? 0]),
      val.partRejected ?? 0,                                         
      val.availability ? parseFloat(val.availability).toFixed(2) : 0,
      val.performance ? parseFloat(val.performance).toFixed(2) : 0,
      val.quality ? parseFloat(val.quality).toFixed(2) : 0,
      val.oee ? parseFloat(val.oee).toFixed(2) : 0,
    ]);

    const departmentSections = [
      {
        table: {
          headerRows: 1,
          widths: Array(headerRow.length).fill("auto"),
          body: [headerRow, ...bodyRows],
        },
        layout: {
          fillColor: (rowIndex: number) =>
            rowIndex === 0
              ? null
              : rowIndex % 2 === 0
                ? "#9ef0f0"
                : "#d9fbfb",
          hLineWidth: () => 0.1,
          vLineWidth: () => 0.1,
        },
        fontSize: 9,
        margin: [0, 0, 0, 10],
      },
    ];

    const pdfObject: any = {
      pageSize: "A3",
      pageOrientation: "landscape",

      header: () => ({
        text: today,
        alignment: "right",
        margin: [0, 5, 20, 0],
        fontSize: 10,
      }),

      footer: (currentPage: number, pageCount: number) => [
        {
          text: `Page ${currentPage} of ${pageCount}`,
          alignment: "center",
          fontSize: 7,
        },
        {
          text: `© ${year} Wimera Systems Pvt Ltd`,
          alignment: "right",
          fontSize: 7,
          margin: [5, 2, 10, 20],
        },
      ],

      content: [
        {
          image: this.base64String,
          width: 140,
          height: 45,
          alignment: "left",
          margin: [-30, -28, 0, 0],
        },
        {
          text: "OPERATOR PERFORMANCE REPORT",
          fontSize: 15,
          bold: true,
          alignment: "center",
          margin: [0, -35, 0, 10],
        },
        {
          text: `(Duration : From ${this.fromDate} to ${this.toDate})`,
          fontSize: 10,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
        {
          canvas: [
            {
              type: "line",
              lineColor: "#007d79",
              x1: -40,
              y1: 0,
              x2: 2000,
              y2: 0,
              lineWidth: 0.05,
            },
          ],
          margin: [0, 0, 0, 10],
        },
        {
          text: `Customer Name: ${this.custName}`,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 5],
        },
        {
          text: `Department: ${this.selectedDepartment}`,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 5],
        },
        {
          text: `Shift: ${this.shiftName}`,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 5],
        },
        {
          columns: [
            {
              image: performancechartImage,
              width: 1100,
              height: 180,
              margin: [0, 5, 10, 20],
            },
          ],
        },
        ...departmentSections,
      ],
    };

    pdfMake.createPdf(pdfObject).download(`${pdfName}.pdf`);
  }

  private exportCsv() {
    if (!this.tableData.length) return;

    const startDate = moment(this.fromDate).format("YYYY-MM-DD");
    const endDate = moment(this.toDate).format("YYYY-MM-DD");

    let csvContent = "";

    // ── Report Title & Details ─────────────────────────────
    csvContent += "OPERATOR REPORT\n";
    csvContent += `\n`;
    csvContent += `DEPARTMENT: ${this.selectedDepartment}\n`;
    csvContent += `\n`;
    csvContent += `Shift: ${this.shiftName}\n`;
    csvContent += `\n`;
    csvContent += `Date: ${startDate} to ${endDate}\n`;
    csvContent += `\n`;

    // ── Headers ─────────────────────────────────────────────
    const headers = [
      "Date",
      "Machine Name",
      "Operator Name",
      "Available Time (mins)",
      "Running (mins)",
      "Idle (mins)",
      ...(this.hasBreakdown ? ["Breakdown (mins)"] : []),
      ...(this.hasInterlock ? ["Interlock (mins)"] : []),
      "Off (mins)",
      "Downtime (mins)",
      "Qty Planned",
      ...(this.hasPin2
        ? ["Part Count 1", "Part Count 2"]
        : ["Qty Produced"]),
      "Qty Rejected",
      "Availability(%)",
      "Performance(%)",
      "Quality(%)",
      "OEE(%)",
    ];

    csvContent += headers.join(",") + "\n";

    // ── Rows ────────────────────────────────────────────────
    this.tableData.forEach((val: any) => {
      const row = [
        val.date ?? "--",
        val.deviceName ?? "--",
        val.operatorName ?? "--",
        val.availableTime ?? 0,
        val.running ?? 0,
        val.idle ?? 0,
        ...(this.hasBreakdown ? [val.breakdown ?? 0] : []),
        ...(this.hasInterlock ? [val.interlock ?? 0] : []),
        val.off ?? 0,
        val.downtime ?? 0,
        val.partPlanned ? parseFloat(val.partPlanned).toFixed(0) : 0,
        ...(this.hasPin2
          ? [val.pin1_count ?? 0, val.pin2_count ?? "NA"]
          : [val.pin1_count ?? 0]),
        val.partRejected ?? 0,
        val.availability ? parseFloat(val.availability).toFixed(2) : 0,
        val.performance ? parseFloat(val.performance).toFixed(2) : 0,
        val.quality ? parseFloat(val.quality).toFixed(2) : 0,
        val.oee ? parseFloat(val.oee).toFixed(2) : 0,
      ];

      csvContent +=
        row
          .map((cell: any) =>
            typeof cell === "string" && /[,"\n]/.test(cell)
              ? `"${cell.replace(/"/g, '""')}"`
              : cell
          )
          .join(",") + "\n";
    });

    // ── Download ────────────────────────────────────────────
    const blob = new Blob(["\ufeff" + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Operator_Report_${startDate}_to_${endDate}.csv`;
    a.click();
    URL.revokeObjectURL(url);

    this.toastr.success("CSV downloaded", "Export");
  }
  private emailExport(type: 'pdf' | 'csv') {
    const emailValue = this.mailform.get('email')?.value;
    if (!emailValue) return;

    const payload = {
      to: emailValue,
      filetype: type,
      customerName: this.custName,
      operatordata: this.tableData,
      departmentId: this.selectedDepartmentId,
      departmentName: this.selectedDepartment,
      reportname: 'operatorReports',
      fromDate: this.fromDate,
      toDate: this.toDate,
      shiftId: this.selectedShiftId,
      shiftName: this.shiftName
    };

    this.dataservice.post("api/sendMail", payload).subscribe(
      (res) => {
        this.toastr.success("Mail sent successfully!");
      },
      (err) => {
        this.toastr.error(err.message);
      }
    );
  }

  get email() {
    return this.mailform.get('email');
  }

  isEmailInvalid(): boolean {
    return !!(this.email?.invalid && (this.email.dirty || this.email.touched));
  }

  convertImageToBase64() {
    const imagePath = 'assets/wimera/Wimera_Logo_wSlogan_Green.png';
    this.http.get(imagePath, { responseType: 'blob' }).subscribe({
      next: (data: Blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.base64String = reader.result as string;
        };
        reader.readAsDataURL(data);
      },
      error: (err) => console.error('Error loading logo image:', err),
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}